import React, { useContext, useEffect, useState } from "react";
import { TYPE_INSTANCE4 } from "App/constants";

import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables, useDatatablesServerSide, useSelectOption } from "App/hooks";
import {
  getMaintenance,
  headCells,
  RESET_STATE_FORM_FILTER,
} from "./helpers";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  InputCheckboxMaster,
  InputOptionMaster,
  InputReactDatepicker,
  Loading,
  MasterButton,
  TableHeader,
} from "App/Component/ui";
import {
  defaultDateDisplay,
  defaultToastError,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import { RenderStatusMTBarang } from "App/Component/layout/FixedAsset/Maintenance/InputMaintenance/helpers";
import { AddIcon } from "App/Assets";
import { STYLE_DEFAULT_TAB_FA } from "../../helpers";

const useStyles = STYLE_DEFAULT_TAB_FA;

export default function TabMaintenance() {
  const classes = useStyles();
  const { dataMaintenance, setDataMaintenance, formData } = useContext(FormContext);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchData = async (
    id = formData.id,
    pages = formFilter.halaman,
    limit = formFilter.jumlah
  ) => {
    setLoading(true);
    const res = await getMaintenance(formFilter, id, pages, limit);
    if (res.state) {
      setDataMaintenance(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setDataMaintenance([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetchData();
  };

  const vendor = useSelectOption(
    true,
    "/wmsMasterAsset/vendor/list",
    TYPE_INSTANCE4
  );

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: fetchData });

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: dataMaintenance,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const [rowsDetail, setrowsDetail] = useState([]);

  const [activeRow, setActiveRow] = useState({
    index: null,
    id: null,
  });
  return (
    <Paper
      className={classes.paper}
      style={{
        padding: "1rem",
        marginBottom: "1rem",
      }}
    >
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3} alignItems="center">
          <Grid item sm={4}>
            <InputReactDatepicker
              selected={formFilter.tglAwal}
              label="TANGGAL"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                  tglAkhir: new Date(e),
                })
              }
              withPeriode={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "1px solid #EAEAEA",
                  background: "#fff",
                  padding: "0 0.8rem 0 0.8rem",
                  cursor: "pointer",
                  // borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                s/d
              </button>
              <InputReactDatepicker
                selected={formFilter.tglAkhir}
                label=""
                minDate={new Date(formFilter.tglAwal)}
                handleChangeToday={(e) =>
                  setFormFilter({
                    ...formFilter,
                    tglAkhir: e,
                  })
                }
                onChange={(e) =>
                  setFormFilter({
                    ...formFilter,
                    tglAkhir: e,
                  })
                }
                withParentPeriode={true}
              />
            </InputReactDatepicker>
            <div
              style={{
                cursor: "pointer",
                // marginTop: "-1.7rem",
                // position: "absolute",
                // left: "2rem",
              }}
            >
              <InputCheckboxMaster
                checked={formFilter.tgl_aktif}
                name="tgl_aktif"
                id="tgl_aktif"
                label="Dengan Tanggal"
                onChange={() =>
                  setFormFilter({
                    ...formFilter,
                    tgl_aktif: !formFilter.tgl_aktif,
                  })
                }
              />
            </div>
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="vendor"
              // label="VENDOR"
              id="vendor"
              value={formFilter.vendor_id}
              labelValue={formFilter.nama_vendor}
              withSearch={true}
              onChange={(e) =>
                isNull(e)
                  ? setFormFilter({
                      ...formFilter,
                      vendor_id: "",
                      nama_vendor: "Pilih Vendor",
                    })
                  : setFormFilter({
                      ...formFilter,
                      vendor_id: e?.value,
                      nama_vendor: e?.label,
                    })
              }
              data={vendor}
            />
          </Grid>
          <Grid item sm={2}>
            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              onClick={handleSubmit}
              type={"submit"}
              size={"md"}
            />
          </Grid>
        </Grid>
        <br />
      </form>

      <Loading show={loading} />
      <TableContainer className="custom-scrollbar">
      <Table
        className={classes.table}
        aria-labelledby="tableTitle"
        size={"medium"}
        aria-label="enhanced table"
      >
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(dataMaintenance, getComparator(order, orderBy)).map((row, index) => {
            return (
              <>
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  // style={{
                  //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  // }}
                >
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">
                    <IconButtonDatatable
                      color="secondary"
                      onClick={() => {
                        if (activeRow.index === index) {
                          setActiveRow({
                            id: null,
                            index: null,
                            
                          });
                          setrowsDetail([]);
                        } else {
                          setActiveRow({
                            id: row.id,
                            index: index,
                          });
                          setrowsDetail(row?.detail_perbaikan);
                        }
                      }}
                    >
                      <AddIcon />
                    </IconButtonDatatable>
                  </TableCell>
                  <TableCell align="left">{row?.id}</TableCell>
                  <TableCell align="left">
                    {isNull(row?.remark) ? "-" : row?.remark}
                  </TableCell>
                  <TableCell align="left">
                    {isNull(row?.kelengkapan) ? "-" : row?.kelengkapan}
                  </TableCell>
                  <TableCell align="center">
                    <RenderStatusMTBarang status={row?.status_barang} />
                  </TableCell>
                  <TableCell align="left">
                    {isNull(row?.no_faktur) ? "-" : row?.no_faktur}
                  </TableCell>
                  <TableCell align="left">
                    {row?.deskripsi_kerusakan === null
                      ? "-"
                      : row?.deskripsi_kerusakan}
                  </TableCell>
                  <TableCell align="left">
                    {row?.is_garansi === false ? "Tidak" : "Ya"}
                  </TableCell>
                  <TableCell align="left">
                    {row?.tanggal_akhir_garansi === null
                      ? "-"
                      : defaultDateDisplay(row.tanggal_akhir_garansi)}
                  </TableCell>
                </TableRow>
                {activeRow.index === index && (
                  <>
                    <TableHeadDetail index={index} />
                    <TableListBarang
                      rowsDetail={rowsDetail}
                    />
                  </>
                )}
              </>
            );
          }
        )}
        {dataMaintenance.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
      <DatatablesFooterServerSide
        totalData={totalData}
        pagination={pagination}
        handleChangeLimit={handleChangeLimit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentPage={pagination.page}
        handleClickPageNumber={handleClickPageNumber}
      />
    </Paper>
  );
}

const TableHeadDetail = ({ index }) => {
  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        key={index}
        style={{
          backgroundColor: "#fff",
        }}
      >
        <TableCell component="th" align="left"></TableCell>
        <TableCell
          component="th"
          scope="row"
          padding="none"
          align="left"
          style={{
            padding: "1.5rem",
          }}
        >
          NO
        </TableCell>

        <TableCell component="th" align="left" colSpan={4}>
          KETERANGAN PENGERJAAN
        </TableCell>

        <TableCell component="th" align="left" colSpan={3}>
          PEMBELIAN
        </TableCell>

        <TableCell component="th" align="left">
          HARGA
        </TableCell>
      </TableRow>
    </>
  );
};

const TableListBarang = ({ rowsDetail }) => {
  return (
    <>
      {Array.isArray(rowsDetail) ? (
        rowsDetail.map((item, index) => {
          return (
            <>
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: "#f3f3f3",
                }}
              >
               <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}.
                </TableCell>
                <TableCell align="left" colSpan={4}>{item?.status}</TableCell>
                <TableCell align="left" colSpan={3}>
                  {isNull(item?.pembelian) ? "-" : item?.pembelian}
                </TableCell>
                <TableCell align="right">
                  {isNull(item?.harga) ? "-" : formatRupiah(item?.harga)}
                </TableCell>
              </TableRow>
            </>
          );
        })
      ) : (
        <TableRow hover tabIndex={-1}>
          <TableCell component="th" align="center" colSpan="11">
            {rowsDetail}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
